import axios from '../plugins/axios';

const COMMON_REQUEST_HEADER = {
  accept: 'application/json',
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache',
  Pragma: 'no-cache',
};

export default {
  getMyPlusAppList() {
    const url = process.env.VUE_APP_HIWORKS_MY_PLUS_API + `/bookmarks`;
    const options = {
      headers: COMMON_REQUEST_HEADER,
    };

    return axios.get(url, options);
  },

  getMyPlusApp(appId) {
    const url = process.env.VUE_APP_HIWORKS_MY_PLUS_API + `/apps/${appId}`;
    const options = {
      headers: COMMON_REQUEST_HEADER,
    };

    return axios.get(url, options);
  },

  patchMyPlusApp(id, data) {
    const url = process.env.VUE_APP_HIWORKS_MY_PLUS_API + `/bookmarks/${id}`;

    const options = {
      headers: COMMON_REQUEST_HEADER,
    };

    return axios.patch(url, data, options);
  },
};
